module.exports = __webpack_public_path__ + "img/2007_L.bbdd92bd.png";